import { render, staticRenderFns } from "./Goodsinfo.vue?vue&type=template&id=29146b44&scoped=true&"
import script from "./Goodsinfo.vue?vue&type=script&lang=js&"
export * from "./Goodsinfo.vue?vue&type=script&lang=js&"
import style0 from "./Goodsinfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Goodsinfo.vue?vue&type=style&index=1&id=29146b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29146b44",
  null
  
)

export default component.exports